import React from "react";
import {PromptContext} from '../providers';

function usePrompt() {
    return React.useContext(PromptContext);
}

export {usePrompt}
